import React, { Component } from 'react';

import Scoreboard from '../Scoreboard';

import '../../styles/modals/LeaderboardModal.css';

class LeaderboardModal extends Component {
  handleScoreboardClick = (playerName, date) => {
    this.props.onClose();
    this.props.onClick(playerName, date);
  }

  handlePlayDailyClick = () => {
    this.props.onClose();
    this.props.onPlayDailyClick();
  }

  render() {
    return (
      <div className="leaderboard-modal">
        <div className="leaderboard-modal-message">
          Note: Try tapping a score to see its board!
        </div>
        <Scoreboard
          clickableToday={this.props.clickableToday}
          loggedInPlayerName={this.props.loggedInPlayerName}
          scores={this.props.scores}
          starMap={this.props.yesterdayStarMap}
          medalMap={this.props.lastWeekMedalMap}
          trophyMap={this.props.lastSeasonTrophyMap}
          onClick={this.handleScoreboardClick}
          onLoginClick={this.props.onLoginClick}
          onPlayDailyClick={this.props.onPlayDailyClick && this.handlePlayDailyClick}
        />

        <button className="leaderboard-modal-close" onClick={this.props.onClose}>
          Close
        </button>
      </div>
    );
  }
}

export default LeaderboardModal;
